import { motion } from 'framer-motion'
import { SiteNav } from '@/components/ui/site-chrome'
import { OrbitCollageHero } from '@/components/ui/orbit-collage-hero'
import { HowItWorksStack, FeatureBlocks, LifeCrafterRing, EventsRail, DailyRituals, ClosingGlassCTA, SiteFooter } from '@/components/ui/hero-sections'
import { IndependenceDayLoader } from '@/components/ui/independence-loader'
import { useSmoothScroll } from '@/lib/useSmoothScroll'
import { usePrefersReducedMotion } from '@/lib/useReducedMotion'
import { cn } from '@/lib/utils'

/* ================================================================== */
/*  LifeCraft4U home: the final "Night Glass" theme. Stormy navy-plum    */
/*  backdrop, frosted glass, 3-beat orbit-collage hero.                */
/* ================================================================== */

function Backdrop() {
  const reduced = usePrefersReducedMotion()
  const blobs = [
    { cls: 'h-[50rem] w-[50rem] -left-56 top-24 opacity-25 md:opacity-45', color: '#7C3AED', anim: { x: [0, 80, 0], y: [0, 50, 0] }, d: 26 },
    { cls: 'h-[42rem] w-[42rem] -right-40 top-[16%] opacity-[0.18] md:opacity-45', color: '#FF6B5C', anim: { x: [0, -70, 0], y: [0, 70, 0] }, d: 33 },
    { cls: 'h-[46rem] w-[46rem] left-[20%] top-[56%] opacity-25 md:opacity-45', color: '#5B21B6', anim: { x: [0, 60, 0], y: [0, -60, 0] }, d: 39 },
    { cls: 'h-[26rem] w-[26rem] right-[14%] bottom-[4%] opacity-10 md:opacity-20', color: '#C8F04B', anim: { x: [0, -50, 0], y: [0, -40, 0] }, d: 29 },
  ]
  return (
    <div className="grain grain-on-dark pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #191231 0%, #130E22 55%, #170F2A 100%)' }} />
      {blobs.map((b, i) => (
        <motion.div
          key={i}
          className={cn('blob', b.cls)}
          style={{ background: b.color }}
          animate={reduced ? undefined : b.anim}
          transition={reduced ? undefined : { duration: b.d, repeat: Infinity, ease: 'easeInOut' }}
        />
      ))}
      <div className="absolute inset-0" style={{ background: 'radial-gradient(120% 90% at 50% 38%, transparent 42%, rgba(8,6,16,0.72) 100%)' }} />
      {/* phones: the blurred blobs bloom brighter on a small canvas, washing the
          bg pink and killing text contrast — lay a darker scrim on mobile only */}
      <div className="absolute inset-0 md:hidden" style={{ background: 'rgba(9,6,18,0.5)' }} />
    </div>
  )
}

export default function Home() {
  useSmoothScroll()
  return (
    <div className="lc-dark relative min-h-screen overflow-x-clip bg-night-800 text-lc-ink">
      <Backdrop />
      <SiteNav />
      <IndependenceDayLoader />
      <main className="relative z-10">
        <OrbitCollageHero theme="dark" />
        <HowItWorksStack dark={true} />
        <FeatureBlocks dark={true} />
        <LifeCrafterRing dark={true} />
        <EventsRail dark={true} />
        <DailyRituals dark={true} />
        {/* Membership section hidden for now */}
        <ClosingGlassCTA dark={true} />
        <SiteFooter dark={true} />
      </main>
    </div>
  )
}
